export class MicPermissionError extends Error {
  constructor(msg: string) {
    super(msg);
    this.name = 'MicPermissionError';
  }
}

export class MicNotFoundError extends Error {
  constructor(msg: string) {
    super(msg);
    this.name = 'MicNotFoundError';
  }
}

export class AudioNotSupportError extends Error {
  constructor(msg: string) {
    super(msg);
    this.name = 'AudioNotSupportError';
  }
}

export function isMicPermissionError(err: unknown): err is MicPermissionError {
  return (err as Error).name === 'MicPermissionError';
}

export function isMicNotFoundError(err: unknown): err is MicNotFoundError {
  return (err as Error).name === 'MicNotFoundError';
}

export function isAudioNotSupportError(err: unknown): err is AudioNotSupportError {
  return (err as Error).name === 'AudioNotSupportError';
}
